var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bs-card',{staticClass:"card-info",staticStyle:{"height":"50vh"},attrs:{"label":_vm.$tc('labels.budget', 1)}},[_c('sunburst',{staticClass:"py-3",attrs:{"data":_vm.tree},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var on = ref.on;
var actions = ref.actions;
return [_c('highlightOnHover',_vm._b({},'highlightOnHover',{ on: on, actions: actions },false)),_c('zoomOnClick',_vm._b({},'zoomOnClick',{ on: on, actions: actions },false))]}},{key:"top",fn:function(ref){
var nodes = ref.nodes;
return _c('nodeInfoDisplayer',{attrs:{"current":nodes.mouseOver,"root":nodes.root,"description":""}})}},{key:"legend",fn:function(ref){
var nodes = ref.nodes;
var colorGetter = ref.colorGetter;
var width = ref.width;
return _c('breadcrumbTrail',{attrs:{"current":nodes.mouseOver,"root":nodes.root,"colorGetter":colorGetter,"from":nodes.clicked,"width":width}})}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }